import { Component, Input } from '@angular/core';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { CardComponent } from '../../../../core/panels/card.component';

@Component({
  selector: 'app-policy-detail',
  imports: [DetailPanelComponent, DetailItemComponent, CardComponent],
  template: `<div class="tw-flex tw-gap-8 tw-pb-8">
      <div class="tw-basis-full">
        <app-card label="Policy">
          <div class="tw-flex tw-gap-8">
            <div class="tw-basis-1/3">
              <app-detail-panel [dataSource]="dataSource">
                <app-detail-item
                  label="Client Account Number"
                  name="clientAccountNumber"
                />
                <app-detail-item
                  label="Alternate Policy Number"
                  name="alternatePolicyNumber"
                />
                <app-detail-item
                  label="Prior Policy Number"
                  name="priorPolicyNumber"
                />
                <app-detail-item
                  label="Prior Alternate Policy Number"
                  name="priorAlternatePolicyNumber"
                />
              </app-detail-panel>
            </div>
            <div class="tw-basis-1/3">
              <app-detail-panel [dataSource]="dataSource">
                <app-detail-item label="Status" name="status" />
                <app-detail-item label="Description" name="description" />
                <app-detail-item
                  label="Effective Date"
                  name="effectiveDate"
                  format="d"
                />
                <app-detail-item
                  label="Expire Date"
                  name="expireDate"
                  format="d"
                />
              </app-detail-panel>
            </div>
            <div class="tw-basis-1/3">
              <app-detail-panel [dataSource]="dataSource">
                <app-detail-item
                  label="Cancel Date"
                  name="cancelDate"
                  format="d"
                />
                <app-detail-item label="Type" name="policyType" />
                <app-detail-item label="Source" name="source" />
                <app-detail-item label="Symbol" name="symbol" />
              </app-detail-panel>
            </div>
          </div>
        </app-card>
      </div>
    </div>
    <div class="tw-flex tw-gap-8 tw-pb-8">
      <div class="tw-basis-1/3">
        <app-card label="Location">
          <app-detail-panel [dataSource]="dataSource">
            <app-detail-item label="Premium state" name="premiumState" />
            <app-detail-item label="Division" name="division" />
            <app-detail-item label="Branch" name="branch" />
            <app-detail-item label="Region" name="region" />
          </app-detail-panel>
        </app-card>
      </div>
      <div class="tw-basis-2/3">
        <app-card label="Other">
          <div class="tw-flex tw-gap-8">
            <div class="tw-basis-1/2">
              <app-detail-panel [dataSource]="dataSource">
                <app-detail-item label="Paper Company" name="paperCompany" />
                <app-detail-item
                  label="Paper Company Tax Number"
                  name="paperCompanyTaxNumber"
                />
                <app-detail-item label="Carrier" name="carrier" />
                <app-detail-item label="NAICS" name="naics" labelCase="none" />
                <app-detail-item label="SIC" name="sic" labelCase="none" />
              </app-detail-panel>
            </div>
            <div class="tw-basis-1/2">
              <app-detail-panel [dataSource]="dataSource">
                <app-detail-item label="Claims Made" name="claimsMade" />
                <app-detail-item
                  label="Retro Date"
                  name="retroDate"
                  format="d"
                />
                <app-detail-item label="Tail Date" name="tailDate" format="d" />
                <app-detail-item label="Comments" name="comments" />
              </app-detail-panel>
            </div>
          </div>
        </app-card>
      </div>
    </div>`,
  styles: [],
})
export class PolicyDetailComponent {
  @Input()
  dataSource: any;
}
